import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

// FIXME : Add to component lib
const HotelStars = ({ rating, setRating, disabled = false, name }) => {
  const [hover, setHover] = useState(0);

  return (
    <div
      style={{
        display: "flex",
        gap: "5px",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {[...Array(5)].map((_, index) => {
        const starValue = index + 1;
        return (
          <FontAwesomeIcon
            key={index}
            id={name ? `${name}Star${starValue}` : undefined}
            icon={faStar}
            size="md"
            color={starValue <= (hover || rating) ? "#FFD700" : "#e4e5e9"}
            onClick={() => !disabled && setRating(starValue)}
            onMouseEnter={() => !disabled && setHover(starValue)}
            onMouseLeave={() => !disabled && setHover(0)}
          />
        );
      })}
    </div>
  );
};

export default HotelStars;
